var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHowitWorksArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 27,
    viewBox: "0 0 143 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 15.165C1 15.165 64.7559 -15.165 130.677 15.165",
    stroke: "white",
    strokeWidth: 1.5,
    strokeDasharray: "4 7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M124.176 25.5132L141.414 20.1649L135.535 3.67505",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowitWorksArrow);
export default __webpack_public_path__ + "static/media/HowitWorksArrow.8e4aece37e39163c59308c8f52da7347.svg";
export { ForwardRef as ReactComponent };